export default __webpack_public_path__ + "static/media/under200.2562cac7.png";